import {
  Box,
  Button,
  InputAdornment,
  Pagination,
  SelectChangeEvent,
  Stack,
  ToggleButton,
  Typography,
} from '@mui/material';
import Page from 'components/Page';
import { StyledToggleButtonGroup } from 'components/StyledComponent';
import React, { useCallback, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import plussIoutlined from '@iconify/icons-ant-design/plus-outlined';
import searchIcon from '@iconify/icons-ant-design/search-outlined';
import useQuery from 'hook/useQuery';
import { API_PATH } from 'common/constants/services';
import { Table, Th, Tr } from 'components/Table';
import ChallengeList from './ChallengeList';
import { ChallengeInput } from './style';
import { ChallengeItem } from './ChallengeList/style';

interface IFormValue {
  search: string;
}

export function Challenge() {
  const navigate = useNavigate();
  const [selectedTag, setSelectedTag] = useState([0]);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const { register, handleSubmit } = useForm<IFormValue>();
  const tags = useQuery<TTags>(API_PATH.TAGS);
  const challengeQuery = useQuery<IChallengeResponse>(API_PATH.CHALLENGES, {
    name: searchText,
    tag_ids: selectedTag.filter((item) => item > 0),
    offset: page * 30 - 30,
  });

  const onSubmit = useCallback((data: IFormValue) => {
    if (data.search.length > 0) {
      setSearchText(data.search);
    }
  }, []);

  const onChangeTag = (event: SelectChangeEvent<number>) => {
    const { value } = event.target;
    const parseValue = Number(value);

    if (selectedTag.includes(parseValue)) {
      setSelectedTag(selectedTag.filter((item) => item !== parseValue));

      return;
    }

    if (parseValue === 0) {
      setSelectedTag([0]);
    } else {
      setSelectedTag([
        ...new Set([...selectedTag.filter((item) => item > 0), parseValue]),
      ]);
    }
  };

  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPage(value);
  };

  const paginationCount = useMemo(() => {
    if (challengeQuery.getQuery.data) {
      return Math.ceil(challengeQuery.getQuery.data.data.count / 30);
    }

    return 0;
  }, [challengeQuery]);

  const refetchQuery = () => {
    challengeQuery.resetQuery();
  };

  return (
    <Page
      actions={
        <Button variant='contained' onClick={() => navigate('/challenges/new')}>
          <Icon icon={plussIoutlined} style={{ marginRight: 4 }} /> 신규루틴
        </Button>
      }
    >
      <Stack direction='row' alignItems='center' mb={1}>
        <Box
          sx={{
            width: 40,
          }}
        >
          <Typography variant='subtitle2'>태그</Typography>
        </Box>
        <StyledToggleButtonGroup
          size='small'
          value={selectedTag}
          exclusive
          onChange={onChangeTag}
          aria-label='태그'
        >
          <ToggleButton value={0} aria-label='전체' color='primary'>
            전체
          </ToggleButton>
          {tags.getQuery.data?.data?.map((tag) => (
            <ToggleButton
              value={tag.id}
              aria-label={tag.name}
              key={tag.id}
              color='primary'
            >
              {tag.name}
            </ToggleButton>
          ))}
        </StyledToggleButtonGroup>
      </Stack>

      <Box mb={6}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ChallengeInput
            fullWidth
            size='small'
            type='text'
            placeholder='루틴 검색'
            {...register('search', { required: true })}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Icon icon={searchIcon} />
                </InputAdornment>
              ),
            }}
          />
        </form>
      </Box>

      {/* card로 변경 */}
      <Table>
        <Tr>
          <Th>루틴명</Th>
          <Th width='100px'>공개여부</Th>
          <Th width='100px'>PRO여부</Th>
          <Th width='200px'>태그</Th>
          <Th width='100px'>기간</Th>
          <Th width='50px'> ㅤ</Th>
        </Tr>
        <ChallengeList
          rows={challengeQuery.getQuery.data?.data.results || []}
          refetchQuery={refetchQuery}
        />
      </Table>
      <Pagination
        count={paginationCount}
        shape='rounded'
        page={page}
        onChange={handlePaginationChange}
      />
    </Page>
  );
}
